import React, { useState, useEffect } from "react";
import { Grid, Divider, useMediaQuery, Stack, Box, Typography, Paper } from "@mui/material";
import { useLocale } from "../context/LocaleContext";
import UploadComponent from "../components/HomePage/Upload";
import { useRedirection } from "../context/RedirectionContext";
import Recorder from "../components/HomePage/Recorder";
import Output from "../components/HomePage/Output";
import CustomMediaPlayer from "../components/HomePage/CustomMediaPlayer";
import CustomButton from "../components/Base/CustomButton";
const langaugeApi = require('../apis/languageApi');

export default function HomePage() {
	const { setRedirection } = useRedirection();

	const { messages } = useLocale();
	const [uploadedFile, setUploadedFile] = useState(null);
	const [audioURL, setAudioURL] = useState('');
	const [audioBlob, setAudioBlob] = useState('');
	const [voiceData, setVoiceData] = useState()
	const match = useMediaQuery('(min-width: 900px)');

	const handleAudioSubmit = () => {
		if (audioBlob) {
			const reader = new FileReader();
			reader.readAsDataURL(audioBlob);
			reader.onloadend = async function () {
				let base64String = reader.result;
				const res = await langaugeApi.synthesizeAudioTranslate(base64String.slice(base64String.indexOf(',') + 1), 'hi', 'en'); // can change
				const en = await langaugeApi.synthesizeAudioTranslate(base64String.slice(base64String.indexOf(',') + 1), 'en', 'en');
				fetch(
					`${process.env.REACT_APP_BACKEND_URL}/audio/all_in_one/MUM1957MH/hi`,
					{
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({ audio_content: { en: res.final_output, hi: en.final_output }, initial_page: '/dashboard' })
					}
				).then(response => {
					if (!response.ok) {
						console.log(`HTTP error! status: ${response.status}`);
					}
					return response.json();
				}).then(data => {
					setVoiceData(data);
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}

	useEffect(() => {
		if (voiceData) {
			switch (voiceData.function_name) {
				case "view_inventory":
					setRedirection('/inventory', { filters: voiceData.filters, itemCategory: voiceData.item_category });
					break;
				case "show_transaction":
					setRedirection('/transactions', { duration: voiceData.duration, itemCategory: voiceData.item_category, filters: voiceData.transaction_type });
					break
				case "generate_report":
					setRedirection('/report', {});
					break;
				default:
					break;
			}
		}
	}, [voiceData])

	const handleSubmit = () => {
		const reader = new FileReader();
		reader.readAsDataURL(audioBlob);
		reader.onloadend = function () {
			let base64String = reader.result;
			console.log('Base64 String - ', base64String);
			fetch(
				`${process.env.REACT_APP_BACKEND_URL}/audio/all_in_one/MUM1957MH/hi`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ audio_content: base64String.slice(base64String.indexOf(',') + 1) })
				}
			).then(response => {
				if (!response.ok) {
					console.log(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			}).then(data => {
				console.log(data);
			})
		}
	}

	return (
		<Grid container direction='column' rowGap={7}>
			{/* <Paper elevation={0} sx={{ height: 50, backgroundColor: 'transparent' }}></Paper> */}
			<Grid item xs={4}>
				<Stack
					direction={match ? 'row' : 'column'}
					divider={<Divider variant="middle" orientation={match ? 'vertical' : 'horizontal'} flexItem />}
					justifyContent="center"
					alignItems="stretch"
					spacing={2}
				>
					<Box
						flexBasis='50%'
						display='flex'
						justifyContent='center'
						alignItems='center'
					>
						{audioURL ?
							<Stack
								flexDirection='row'
								gap={2}
								alignItems='center'
							>
								<CustomMediaPlayer mediaUrl={audioURL} clearAudio={() => setAudioURL('')} />
							</Stack>
							:
							<Stack
								flexDirection='row'
								gap={2}
								alignItems='center'
							>
								<Recorder setAudioURL={setAudioURL} setAudioBlob={setAudioBlob} />
								<Typography>{messages.homepage.recorder}</Typography>
							</Stack>
						}
					</Box>
					{/* <Box flexBasis='50%' display='flex' justifyContent='center'>
						<UploadComponent setUploadedFile={setUploadedFile} phoneDisplay={phoneDisplay} />
					</Box> */}
				</Stack>
			</Grid>
			<Grid item xs={1} textAlign='center'>
				<CustomButton onClick={handleAudioSubmit} variant="contained" disabled={!(audioURL || uploadedFile)} sx={{ width: 180, height: 40 }}>{messages.common.confirm}</CustomButton>
			</Grid>
			<Grid item xs={3}>
				{/* <Output message='Hi' /> */}
				{uploadedFile && <img
					src={URL.createObjectURL(uploadedFile)}
					alt={uploadedFile.name}
					style={{ width: '100%', maxWidth: '300px', marginTop: '20px' }}
				/>}
			</Grid>
		</Grid>
	);
}
